import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import { Observable, pipe } from 'rxjs';
import {catchError, map} from 'rxjs/operators'
import { environment } from 'src/environments/environment';
import { CommonService } from './common-service.service';
import { HttpService } from './http.service';
import { 
   CabAllocationList,
   CabInOutModelMap,
   CabInwardOutwardList } from '../model/cab-booking.model';
import { 
  CabBookingModelMap , 
  CabBookingRequestModelMap} from '../model/cab-booking.model';
@Injectable({
  providedIn: 'root'
})
export class CabBookingService{
hostname=environment.apiEndpoint;
cabAllocateObj:CabAllocationList;
cabInwardOutwardObj:CabInwardOutwardList;
modelMap: CabBookingModelMap = new CabBookingModelMap();
modelCabRequestMap: CabBookingRequestModelMap = new CabBookingRequestModelMap();
cabInOutModelMap: CabInOutModelMap = new CabInOutModelMap();
constructor(private _http : HttpClient, private commonService: CommonService, private httpService: HttpService) { }

  PostCabBooking(servicePath:any,data : any){
    let headers = this.commonService.getHeaders();
    const httpOptions = { headers: headers };
    return this._http.post(this.hostname + servicePath, data, httpOptions).pipe(catchError(this.handleError));
  }

  GetCabBooking(servicePath:any,data:any){
    let headers = this.commonService.getHeaders();
    const httpOptions = { headers: headers };
    return this._http.get<any>(this.hostname + servicePath, httpOptions).pipe(catchError(this.handleError))
  }

  ViewCabBooking(servicePath:any){
    let headers = this.commonService.getHeaders();
    const httpOptions = { headers: headers };
    return this._http.get<any>(this.hostname + servicePath, httpOptions).pipe(catchError(this.handleError))
  }

  getSystemDate(servicePath:any){
    let headers = this.commonService.getHeaders();
    const httpOptions = { headers: headers };
    return this._http.get<any>(this.hostname + servicePath, httpOptions).pipe(catchError(this.handleError))
  }
  private handleError(error: HttpErrorResponse) {
    console.log(error)
    return Observable.throw(error.message || "Server Error")
  }
}
